import { render, staticRenderFns } from "./PDFFormSettingsForm.vue?vue&type=template&id=54cdee28&scoped=true&"
import script from "./PDFFormSettingsForm.vue?vue&type=script&lang=js&"
export * from "./PDFFormSettingsForm.vue?vue&type=script&lang=js&"
import style0 from "./PDFFormSettingsForm.vue?vue&type=style&index=0&id=54cdee28&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54cdee28",
  null
  
)

export default component.exports